import styled from 'styled-components';

export const PointExpirePreviewContainerStyled = styled.div`
  .info_card {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 1.25rem;
    padding: 16px 20px;
    border: 1px solid ${({ theme }) => theme.COLORS.BLUE_1};
    border-radius: 10px;
    background: linear-gradient(90deg, ${({ theme }) => theme.COLORS.BLUE_5} 0%, ${({ theme }) => theme.COLORS.WHITE_1} 100%);
    .info_icon {
      flex-shrink: 0;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${({ theme }) => theme.COLORS.BLUE_1};
      color: ${({ theme }) => theme.COLORS.BLUE_4};
    }
    .info_body {
      flex: 1;
      min-width: 0;
    }
    .info_title {
      margin-bottom: 6px;
      color: ${({ theme }) => theme.COLORS.BLUE_7};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .info_desc {
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      line-height: 1.6;
    }
    .info_note {
      margin-top: 8px;
      display: flex;
      align-items: flex-start;
      gap: 6px;
      padding: 8px 12px;
      border-radius: 8px;
      background: #fff8ec;
      border: 1px solid #ffd9a8;
      color: #8a4b00;
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      line-height: 1.6;
      svg {
        flex-shrink: 0;
        margin-top: 3px;
      }
    }
  }
  .filter_layout {
    margin-bottom: 1rem;
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    row-gap: 10px;
    column-gap: 10px;
    .filter_item {
      width: 200px;
    }
    .period_item {
      width: 420px;
    }
    .filter_checks {
      display: flex;
      flex-direction: column;
      row-gap: 6px;
      padding-bottom: 10px;
    }
    .btn_action_filter {
      width: 147px;
      flex-shrink: 0;
    }
  }
  .empty {
    padding: 3rem;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .period_card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 1rem;
    padding: 14px 20px;
    border: 1px solid #dbe4f0;
    border-radius: 10px;
    background: #f7f9fc;
    .period_key {
      color: ${({ theme }) => theme.COLORS.BLUE_7};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      margin-bottom: 4px;
    }
    .period_line {
      color: ${({ theme }) => theme.COLORS.BLUE_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
      b {
        color: ${({ theme }) => theme.COLORS.BLUE_7};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      }
    }
    .period_side {
      text-align: right;
      flex-shrink: 0;
    }
    .period_meta {
      margin-top: 6px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    }
    .state_badge {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 12px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      background: ${({ theme }) => theme.COLORS.GRAY_1};
      color: ${({ theme }) => theme.COLORS.GRAY_2};
    }
    .state_done {
      background: #e3f4e3;
      color: ${({ theme }) => theme.COLORS.GREEN_1};
    }
    .state_due {
      background: #fde4e4;
      color: #c62828;
    }
    .state_wait {
      background: #fff3dc;
      color: #b26a00;
    }
  }
  @media (max-width: ${({ theme }) => theme.SCREENS.LAPTOP}) {
    .period_card {
      flex-wrap: wrap;
      .period_side {
        text-align: left;
      }
    }
  }
  .summary_row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 1rem;
    .summary_card {
      flex: 1;
      min-width: 150px;
      padding: 12px 16px;
      border: 1px solid #dbe4f0;
      border-radius: 10px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      .summary_label {
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
      .summary_value {
        margin-top: 2px;
        color: ${({ theme }) => theme.COLORS.BLUE_7};
        font-size: ${({ theme }) => theme.FONT.SIZE.S22};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
      }
      &.card_primary {
        border-color: ${({ theme }) => theme.COLORS.BLUE_1};
        background: ${({ theme }) => theme.COLORS.BLUE_5};
        .summary_value {
          color: ${({ theme }) => theme.COLORS.BLUE_4};
        }
      }
      &.card_danger {
        border-color: #f5c2c2;
        background: #fff5f5;
        .summary_value {
          color: #c62828;
        }
      }
      &.card_warn {
        border-color: #ffd9a8;
        background: #fff8ec;
        .summary_value {
          color: #b26a00;
        }
      }
    }
  }
  .result_head {
    margin-bottom: 6px;
    color: ${({ theme }) => theme.COLORS.BLUE_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
  }
  .sub_text {
    font-size: 12px;
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .expire_value {
    color: #c62828;
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .flag_mismatch {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    white-space: nowrap;
    background: #fde4e4;
    color: #c62828;
    cursor: help;
  }
  .reason_text {
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #c62828;
    font-size: 12px;
  }
  .link_btn {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.COLORS.BLUE_4};
    color: ${({ theme }) => theme.COLORS.BLUE_4};
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      background: ${({ theme }) => theme.COLORS.BLUE_5};
    }
  }
`;
